// removed by extract-text-webpack-plugin
module.exports = {"image":"image","image-source":"image-source","image-default":"image-default","image-loader":"image-loader","missing":"missing","loading":"loading"};


//////////////////
// WEBPACK FOOTER
// ./src/common/component/image/image.style.sass
// module id = z01G
// module chunks = 3